<div class="service-unavailable__header">
  <!-- In questa barra c'e' solo la marca: il nome si legge anche sul telefono. -->
  <dxp-header-brand [name]="labels.brandName" [markUrl]="markUrl" [nameAlwaysVisible]="true" />
</div>

<div class="service-unavailable__content">
  <section class="service-unavailable" role="alert" aria-labelledby="service-unavailable-title">
    <h1 #title id="service-unavailable-title" class="service-unavailable__title" tabindex="-1">
      {{ labels.title }}
    </h1>

    <p class="service-unavailable__message">{{ labels.message }}</p>

    <button type="button" class="service-unavailable__action" (click)="onActionClick()">
      {{ labels.action }}
    </button>
  </section>
</div>
